<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="600px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ method === "post" ? "Add" : "Edit" }} Transfer Country</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="country"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row>
              <v-col cols="6">
                <custom-select
                  :items="countries"
                  name="name"
                  item-text="name"
                  item-value="name"
                  label="Country"
              /></v-col>
              <v-col cols="6">
                <custom-input
                  name="sending_min_amount"
                  type="number"
                  label="Sending Min Amount (€)"
                />
              </v-col>
              <v-col cols="6">
                <custom-input
                  name="sending_max_amount"
                  type="number"
                  label="Sending Max Amount (€)"
                />
              </v-col>
              <v-col cols="6">
                <custom-input
                  name="receiving_min_amount"
                  type="number"
                  label="Receiving Min Amount (€)"
                />
              </v-col>
              <v-col cols="6">
                <custom-input
                  name="receiving_max_amount"
                  type="number"
                  label="Receiving Max Amount (€)"
                />
              </v-col>
              <v-col cols="6">
                <custom-select
                  name="is_sending_country"
                  :items="[
                    { text: 'Yes', value: true },
                    { text: 'No', value: false },
                  ]"
                  label="Is Sending Country"
                />
              </v-col>
              <v-col cols="6">
                <custom-select
                  name="risk_score"
                  :items="[{ id: 1, name: 'Low' }, { id: 2, name: 'Medium' }, { id: 4, name: 'High' }]"
                  item-text="name"
                  item-value="id"
                  label="Risk level"
                />
              </v-col>
              <v-col cols="6">
                <custom-select
                  name="continent"
                  :items="[
                    { text: 'Africa', value: 'africa' },
                    { text: 'Antarctica', value: 'antarctica' },
                    { text: 'America', value: 'america' },
                    { text: 'Asia', value: 'asia' },
                    { text: 'Europa', value: 'europa' },
                    { text: 'Oceania', value: 'oceania' },
                  ]"
                  label="Continent"
                />
              </v-col>
              <v-col cols="6">
                <custom-select
                  name="requires_post_code"
                  :items="[
                    { text: 'Yes', value: true },
                    { text: 'No', value: false },
                  ]"
                  label="Requires Post Code"
                />
              </v-col>
              <v-col cols="6">
                <custom-select
                  name="preferred_notification_channel"
                  :items="[
                    { text: 'mail', value: 'mail' },
                    { text: 'sms', value: 'sms' },
                  ]"
                  label="Preferred notification channel"
                />
              </v-col>
              <v-col cols="6">
                <custom-select
                  name="currency_id"
                  :items="currencies"
                  label="Currency"
                />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  {{ method === "post" ? "Add" : "Edit" }}
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    country: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return { 
      countries: [],
      currencies: []
    };
  },
  computed: {
    url() {
      if (this.country && this.country.id) {
        return `api/v1/transactions/transferCountries/${this.country.id}`;
      }
      return "api/v1/transactions/transferCountries";
    },
  },
  created() {
    this.$http.get("/api/v1/get-countries").then((response) => (this.countries = response));
    this.$http.get("/api/v1/payment-currencies/all").then((response) => (this.currencies = response));
  },
};
</script>
